(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[197],{

/***/ 6141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(4230);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PageLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5124);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(863);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2261);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(959);













var PageLayout = function(param) {
    var children = param.children, _crumb = param.crumb, crumb = _crumb === void 0 ? [] : _crumb, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "white" : _backgroundColor, _banner = param.banner, banner = _banner === void 0 ? "/image/about-banner.png" : _banner, newsPath = param.newsPath;
    var ref, ref1;
    var nav = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_stores__WEBPACK_IMPORTED_MODULE_10__/* .IndexContext */ .Z).nav;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), menu = ref2[0], setMenu = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), active = ref3[0], setActive = ref3[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visible = ref4[0], setVisible = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSearch = ref5[0], setIsSearch = ref5[1];
    var navTo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(e, item) {
        if (router.asPath == item.path) {
            return;
        }
        e.stopPropagation();
        // if (item.path === '/audience/register') {
        //   setVisible(true)
        //   return
        // }
        if (item.outlink) {
            var a = document.createElement("a");
            a.href = "".concat(item.outlink);
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return;
        }
        router.push(item.path, item.path, {
            shallow: true
        });
    }, [
        active,
        nav
    ]);
    var searchNode = function(data, path) {
        for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i++){
            var item = data[i];
            if (item.path === path) {
                return item;
            }
            if (item.children && Array.isArray(item.children)) {
                var found = searchNode(item.children, path);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };
    // useEffect(() => {
    //   const { text } = router.query;
    //   setIsSearch(!!text)
    // }, [router.query])
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var act = searchNode(nav, newsPath || router.asPath);
        setActive(act);
        var item = nav === null || nav === void 0 ? void 0 : nav.find(function(item) {
            return item.id === (act === null || act === void 0 ? void 0 : act.parent);
        });
        setMenu(item);
    }, [
        nav
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            backgroundColor: backgroundColor
        },
        className: "jsx-de198927e153d424" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().page) || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-de198927e153d424" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageBg) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: banner,
                        alt: "",
                        className: "jsx-de198927e153d424"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-de198927e153d424" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageHeader) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-de198927e153d424",
                                children: "有机，可持续生活之美"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-de198927e153d424",
                                children: (menu === null || menu === void 0 ? void 0 : menu.name) || (active === null || active === void 0 ? void 0 : active.name)
                            }),
                            !isSearch && (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-de198927e153d424",
                                children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                className: "jsx-de198927e153d424" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()([
                                    (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageNav)
                                ]) || ""),
                                children: menu === null || menu === void 0 ? void 0 : (ref = menu.children) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            zIndex: "100",
                                            background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#93d40b" : ""
                                        },
                                        onClick: function(e) {
                                            return navTo(e, item);
                                        },
                                        className: "jsx-de198927e153d424",
                                        children: item.name
                                    }, item.id);
                                })
                            })),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().swiper),
                                modules: [],
                                spaceBetween: 15,
                                slidesPerView: "auto",
                                style: {
                                    display: "none"
                                },
                                children: [
                                    !isSearch && (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "jsx-de198927e153d424",
                                        children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-de198927e153d424",
                                        children: menu === null || menu === void 0 ? void 0 : (ref1 = menu.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        zIndex: "100",
                                                        background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#93d40b" : ""
                                                    },
                                                    onClick: function(e) {
                                                        return navTo(e, item);
                                                    },
                                                    className: "jsx-de198927e153d424" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().swiperList) || ""),
                                                    children: item.name
                                                })
                                            }, item.id);
                                        })
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-de198927e153d424" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().crumb) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/image/crumb-icon.png",
                        alt: "",
                        className: "jsx-de198927e153d424"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Breadcrumb */ .aG, {
                        compact: false,
                        routes: [
                            {
                                path: "/",
                                name: "首页"
                            },
                            {
                                path: (active === null || active === void 0 ? void 0 : active.path) || (menu === null || menu === void 0 ? void 0 : menu.path) || "",
                                name: (menu === null || menu === void 0 ? void 0 : menu.name) || "",
                                isShow: !menu
                            },
                            {
                                path: (active === null || active === void 0 ? void 0 : active.path) || "",
                                name: (active === null || active === void 0 ? void 0 : active.name) || "",
                                isShow: !active
                            }
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(crumb)).filter(function(item) {
                            return !item.isShow;
                        }),
                        onClick: function(item) {
                            router.push(item.path, item.path, {
                                shallow: true
                            });
                        },
                        separator: ">"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-de198927e153d424" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()([
                    (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().content),
                    "content"
                ]) || ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "jsx-de198927e153d424",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        className: "jsx-de198927e153d424",
                        children: children
                    })
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "de198927e153d424",
                children: '.semi-navigation{border:none!important;padding:0!important}.semi-navigation-header-text{width:100%}.semi-navigation-header{padding:0!important;margin-top:40px}.semi-navigation-item{height:auto!important;padding:0 12px!important}.semi-navigation-item-text{display:block;width:100%}.semi-navigation-footer{position:absolute;top:0;left:20%}.semi-navigation-list-wrapper{height:auto!important;padding:0!important;margin:10px 0}.semi-breadcrumb-item-active{color:#094020!important}.semi-navigation-collapsed{height:70px!important}.semi-breadcrumb-item-link:hover{color:#808080}.semi-notification-notice{min-width:"200px"}.swiper-wrapper,.swiper-slide{width:auto}.semi-breadcrumb-item-wrap{margin:4px 6px}'
            })
        ]
    });
};


/***/ }),

/***/ 4230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1520);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);





var Default = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    // useEffect(() => {
    //   router.push('/apply', '/apply', {
    //     shallow: true
    //   })
    // }, [])
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_2__/* .PageLayout */ .X, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                width: "50%",
                margin: "auto",
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                style: {
                    margin: "0 auto 60px"
                },
                src: "/image/continue.png",
                alt: ""
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Default);


/***/ }),

/***/ 5124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__raIZH","pageBg":"styles_pageBg__uSGYm","pageHeader":"styles_pageHeader__Kkw7J","pageNav":"styles_pageNav__UKUc2","crumb":"styles_crumb__IAstN","content":"styles_content__eWsF4","swiper":"styles_swiper__r2mXM","swiperList":"styles_swiperList__Bj6Lh"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,774,888,179], function() { return __webpack_exec__(6141); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);